module.exports = __webpack_public_path__ + "static/media/pink_leaf.930daf32.png";